module.exports = __webpack_public_path__ + "img/diamondbacks.ec8a5714.svg";